import { useGetShouldShowPatientAVS } from './useGetShouldShowPatientAVS';
import { useGetShouldShowReflectionTopics } from './useGetShouldShowReflectionTopics';

export function useReflectionDrawerVisibility() {
  const { shouldShowReflectionTopics } = useGetShouldShowReflectionTopics();
  const { getShouldShowPatientAVS } = useGetShouldShowPatientAVS();
  const showAVS = getShouldShowPatientAVS();

  return {
    shouldShow: shouldShowReflectionTopics || showAVS,
    showAVS,
  };
}
